import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './Style.css';
import ApiSender from '../../common/ApiLogic';
import useLanguage from '../../common/useLanguage';
import { SUPPORT_EMAIL, COMPANY_NAME, COMPANY_LOCATION } from '../../common/constants';
import Header from './components/Header';
import SiteFooter from './components/Footer';

function PrivacyPage() {
  const location = useLocation();
  const apiSender = useMemo(() => new ApiSender(), []);
  const { language, selectLanguage, t } = useLanguage(location, apiSender);

  return (
    <div className="Ks-page">
      <Header language={language} onSelectLanguage={selectLanguage} />

      <div className="legal-page">
        <h1>{t('Политика конфиденциальности', 'Купуялуулук саясаты', 'Privacy Policy')}</h1>

        {language === 'RU' ? (
          <>
            <p>
              Настоящая политика описывает, какие данные собираются в рамках подписки на сервис родительского
              контроля Kid Security («Сервис») при подключении через оператора Mega, и как они используются.
            </p>

            <h3>1. Какие данные собираются</h3>
            <ul>
              <li>номер телефона абонента, используемый для оформления и биллинга подписки;</li>
              <li>статус подписки и история операций (подключение, продление, отмена);</li>
              <li>технические данные страницы (язык интерфейса, параметры перехода на сайт).</li>
            </ul>
            <p>
              Данные, обрабатываемые непосредственно приложением Kid Security после его установки (геолокация,
              настройки контроля и т.д.), описаны в политике конфиденциальности самого приложения.
            </p>

            <h3>2. Цели обработки данных</h3>
            <ul>
              <li>подключение, продление и отмена подписки;</li>
              <li>взаимодействие с биллинговой системой оператора Mega;</li>
              <li>обработка обращений в службу поддержки.</li>
            </ul>

            <h3>3. Передача данных</h3>
            <p>
              Номер телефона и статус подписки передаются оператору Mega в объёме, необходимом для выставления
              счёта и предоставления услуги. Данные не продаются третьим лицам и не используются в рекламных целях.
            </p>

            <h3>4. Хранение и защита данных</h3>
            <p>
              Данные хранятся не дольше, чем это необходимо для целей, указанных выше, и для соблюдения требований
              законодательства, и защищаются организационными и техническими мерами, соразмерными характеру данных.
            </p>

            <h3>5. Ваши права</h3>
            <p>
              Вы можете запросить информацию о данных, связанных с вашим номером телефона, а также их удаление,
              написав на <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>. Отмена подписки не требует
              отдельного запроса и доступна через способы, указанные в Условиях использования.
            </p>

            <h3>6. Контакты</h3>
            <p>
              Оператор Сервиса: {COMPANY_NAME}, {COMPANY_LOCATION}. По вопросам обработки данных пишите на{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
            </p>
          </>
        ) : language === 'KY' ? (
          <>
            <p>
              Бул саясат Mega операторунун жардамы менен туташтырылган Kid Security ата-эне көзөмөл кызматына
              («Кызмат») жазылуу учурунда кандай маалыматтар чогултулаарын жана алар кантип колдонуларын сүрөттөйт.
            </p>

            <h3>1. Кандай маалыматтар чогултулат</h3>
            <ul>
              <li>жазылууну ырастоо жана эсептен алуу үчүн колдонулган абонттун телефон номери;</li>
              <li>жазылуунун статусу жана операциялардын тарыхы (туташуу, узартуу, баш тартуу);</li>
              <li>баракчанын техникалык маалыматтары (интерфейс тили, сайтка өтүү параметрлери).</li>
            </ul>
            <p>
              Kid Security колдонмосу орнотулгандан кийин түздөн-түз колдонмо тарабынан иштетилген маалыматтар
              (геолокация, көзөмөл жөндөөлөрү ж.б.) колдонмонун өзүнүн купуялуулук саясатында сүрөттөлгөн.
            </p>

            <h3>2. Маалыматтарды иштетүү максаттары</h3>
            <ul>
              <li>жазылууну туташтыруу, узартуу жана жокко чыгаруу;</li>
              <li>Mega операторунун эсептен алуу тутуму менен өз ара аракеттенүү;</li>
              <li>колдоо кызматына кайрылууларды иштетүү.</li>
            </ul>

            <h3>3. Маалыматтарды берүү</h3>
            <p>
              Телефон номери жана жазылуу статусу эсеп чыгаруу жана кызматты көрсөтүү үчүн зарыл көлөмдө Mega
              операторуна берилет. Маалыматтар үчүнчү жактарга сатылбайт жана жарнама максатында колдонулбайт.
            </p>

            <h3>4. Сактоо жана коргоо</h3>
            <p>
              Маалыматтар жогоруда көрсөтүлгөн максаттар жана мыйзам талаптары үчүн зарыл болгон мөөнөткө гана
              сакталат жана маалыматтын мүнөзүнө ылайык уюштуруучулук жана техникалык чаралар менен корголот.
            </p>

            <h3>5. Сиздин укуктарыңыз</h3>
            <p>
              Сиз <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> дарегине жазуу менен телефон номериңизге
              байланыштуу маалыматтар жөнүндө маалымат сурай аласыз, ошондой эле аларды өчүрүүнү сурай аласыз.
              Жазылуудан баш тартуу үчүн өзүнчө өтүнүч талап кылынбайт — Колдонуу шарттарында көрсөтүлгөн
              жолдор аркылуу жеткиликтүү.
            </p>

            <h3>6. Байланыш</h3>
            <p>
              Кызматтын оператору: {COMPANY_NAME}, {COMPANY_LOCATION}. Маалыматтарды иштетүү боюнча суроолор
              үчүн <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> дарегине жазыңыз.
            </p>
          </>
        ) : (
          <>
            <p>
              This policy describes what data is collected as part of a subscription to the Kid Security
              parental control service (the "Service") when signing up through the Mega operator, and how
              that data is used.
            </p>

            <h3>1. What data is collected</h3>
            <ul>
              <li>the subscriber's phone number, used to set up and bill the subscription;</li>
              <li>subscription status and operation history (activation, renewal, cancellation);</li>
              <li>technical page data (interface language, referral parameters).</li>
            </ul>
            <p>
              Data processed directly by the Kid Security app after installation (location, control settings,
              etc.) is described in the app's own privacy policy.
            </p>

            <h3>2. Purposes of data processing</h3>
            <ul>
              <li>activating, renewing and cancelling the subscription;</li>
              <li>interacting with the Mega operator's billing system;</li>
              <li>handling support requests.</li>
            </ul>

            <h3>3. Data sharing</h3>
            <p>
              The phone number and subscription status are shared with the Mega operator to the extent
              necessary for billing and providing the service. Data is not sold to third parties or used for
              advertising purposes.
            </p>

            <h3>4. Storage and protection</h3>
            <p>
              Data is kept no longer than necessary for the purposes above and for legal compliance, and is
              protected with organizational and technical measures appropriate to its sensitivity.
            </p>

            <h3>5. Your rights</h3>
            <p>
              You can request information about data linked to your phone number, or request its deletion, by
              writing to <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>. Cancelling the subscription
              does not require a separate request — it's available through the methods listed in the Terms of Use.
            </p>

            <h3>6. Contact</h3>
            <p>
              Service operator: {COMPANY_NAME}, {COMPANY_LOCATION}. For questions about data processing, write
              to <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
            </p>
          </>
        )}
      </div>

      <SiteFooter t={t} language={language} />
    </div>
  );
}

export default PrivacyPage;
